import ImageSlider from "../blocks/image-slider";

const Home = {
  init() {
    new ImageSlider(".home-info .image-slider");
    this.destinations();
  },

  destinations() {
    $('.dest__explore a').on('mouseenter', function () {
      const country = $(this).data('id');
      $(`#dest-${country}`).children('.dest-country__over').addClass('visible');
    }).on('mouseleave', function () {
      $('.dest-country__over').removeClass('visible');
    });

    // Redirect URL to clicked country
    $('.dest-country').on('click', function () {
      const url = $(this).data('url');
      if (url === '' || url === undefined) {
        return;
      };
      window.location.href = url;
    })
  }
};

export default Home;
